import React from "react";
import { Input } from "antd";

import { trb, i18 } from "../../../Utilities";

export const InputOnlyFormField = props => {
  const { size, disabled, meta } = props;

  return (
    <>
      <Input
        {...props.input}
        autoComplete="none"
        autoCorrect="off"
        autoCapitalize="none"
        spellCheck="off"
        size={size}
        disabled={disabled}
        name={props.input.name}
        value={props.input.value}
        onChange={props.input.onChange}
        type={props.inputType}
        autoFocus={props.autoFocus}
        addonBefore={props.addonBefore}
        suffix={props.suffix}
        maxLength={props.maxLength}
        placeholder={trb(i18.Labels.PhonePrefix)}
      />
      <div
        style={{ top: 47, zIndex: 1, direction: "rtl" }}
        className={"position-absolute form-field-error col-12 pr-1"}
      >
        {meta.touched && (meta.error || meta.submitError)}
      </div>
    </>
  );
};
